export const allowNoneCategories = [
  'Keyboards',
  'Optical Drives',
  'Operating Systems',
  'Cooling Products',
  'RAID Controllers',
  'Monitors',
  'Mouse Pads',
  'Mice',
  'Wireless Networking',
  'Speakers',
];
export const allowQty = [
  { category: 'Processors', maxQty: 2 },
  { category: 'Hard Drives', maxQty: 4 },
  { category: 'Memory', maxQty: 2 },
  { category: 'Video Cards', maxQty: 2 }
];

export const NoneOption = {

}
